import { NavigateFunction, Location } from "react-router-dom";

export const history: {
  location: Location<any>|null,
  navigate: NavigateFunction|null,
} = {
  location: null,
  navigate: null,
}
